import { render, staticRenderFns } from "./ProductDetailLeaflet.vue?vue&type=template&id=2bbbe608"
import script from "./ProductDetailLeaflet.vue?vue&type=script&lang=js"
export * from "./ProductDetailLeaflet.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailLeaflet.vue?vue&type=style&index=0&id=2bbbe608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports